import { updateCounter } from "./CountersUtils";
import { isElementScanRequired, isMouseEvent, showScanRequiredPopup, setManualConfirmation } from "./ScanRequirementUtils";

/**
 * Obsługa kliknięcia w składowe produktu typu bundle (zestawu)
 * 
 * @param {*} event 
 * @param {*} item 
 * @param {*} parent 
 * @param {*} scan_bundle_element_as_single_qty 
 * @param {*} bundle_select 
 * @param {*} toggleConfirmButton 
 */
export function handleBundleCheckboxClick(event, item, parent, scan_bundle_element_as_single_qty, bundle_select, toggleConfirmButton) {
  const checkbox = event.currentTarget;
  const bundleItem = checkbox.closest('.bundleItem');
  const parentElement = checkbox.closest('.produkt.ramka');
  const counterElement = bundleItem && bundleItem.querySelector('.smaller.counter');

  if (isMouseEvent(event)) {
    if (isElementScanRequired(bundleItem)) {
      showScanRequiredPopup();
      return;
    }
    setManualConfirmation(bundleItem, !checkbox.classList.contains('checked') || Boolean(counterElement));
  }

  /** Obsługa pojedynczego skanowania składowych zestawu */
  if (scan_bundle_element_as_single_qty && counterElement) {
    const qtyUom = parseInt(counterElement.dataset.qtyUom, 10);
    let currentCount = parseInt(counterElement.dataset.count, 10) || 0;

    if (currentCount < qtyUom) {
      currentCount += 1;
      updateCounter(counterElement, currentCount);

      const qtySpan = parentElement.querySelector('.qty span');
      const product_uom_qty = qtySpan ? parseInt(qtySpan.dataset.qty, 10) || 1 : 1;
      updateMainBundleCounter(parentElement, product_uom_qty);
    }

    if (currentCount === qtyUom) {
      checkbox.classList.add('checked');

      if (allCountersFull(parentElement)) {
        const parentCheckbox = parentElement.querySelector('.mainCheckbox');
        if (parentCheckbox && !parentCheckbox.classList.contains('checked')) {
          const prodsCount = parseInt(parentElement.dataset.prods, 10) || 1;
          for (let i = 0; i < prodsCount; i++) {
            parent.checkboxClick({ currentTarget: parentCheckbox }, prodsCount);
          }
        }
      }
      toggleConfirmButton();
    }
  } else {
    // Standardowe skanowanie składowych. Kliknięcie zaznacza checkbox, bez spawdzania ilości
    // Nie ma licznika produktów przy tej opcji
    if (checkbox.classList.contains('checked')) {
      checkbox.classList.remove('checked');
    } else {
      checkbox.classList.add('checked');
    }

    const allChecked = areAllBundleItemsChecked(parentElement);
    const mainCheckbox = parentElement.querySelector('.mainCheckbox');
    if (mainCheckbox) {
      if (allChecked) mainCheckbox.classList.add('checked');
      else mainCheckbox.classList.remove('checked');
    }

    updateMainBundleCounterFromCheckboxes(parentElement);
    toggleConfirmButton();
  }
}

/**
 * Sprawdza, czy każdy `.smaller.counter` osiągnął wymaganą ilość (tryb pojedynczego skanowanie zestawów).
 * 
 * @param {*} parentElement 
 * @returns 
 */
function allCountersFull(parentElement) {
  const counters = parentElement.querySelectorAll('.bundleItemList .smaller.counter');
  return Array.from(counters).every(counter => {
    const qtyUom = parseInt(counter.dataset.qtyUom, 10);
    const currentCount = parseInt(counter.dataset.count, 10) || 0;
    return currentCount >= qtyUom;
  });
}

/**
 * Sprawdza, czy wszystkie checkboxy składowe są zaznaczone (tryb bez liczników).
 * 
 * @param {*} parentElement 
 * @returns 
 */
function areAllBundleItemsChecked(parentElement) {
  const boxes = parentElement.querySelectorAll('.bundleItemList .checkbox.multiproduct');
  return Array.from(boxes).every(box => box.classList.contains('checked'));
}

/**
 * Aktualizuje licznik „x / y” przy głównym produkcie
 * na podstawie zaznaczonych checkboxów składowych (tryb bez liczników).
 * 
 * @param {*} parentElement 
 */
function updateMainBundleCounterFromCheckboxes(parentElement) {
  const qtySpan = parentElement.querySelector('.qty span');
  const productQty = qtySpan ? parseInt(qtySpan.dataset.qty, 10) || 1 : 1;
  const groupedCounter = parentElement.querySelector('.grouped_counter_count');
  if (groupedCounter) {
    const fullSets = areAllBundleItemsChecked(parentElement) ? productQty : 0;
    updateCounter(groupedCounter, fullSets);
  }
}

/**
 * Aktualizuje licznik „x / y” przy głównym produkcie
 * na podstawie wartości `.smaller.counter` (tryb pojedynczego skanowania zestawów).
 * 
 * @param {*} parentElement 
 * @param {*} productQty 
 * @returns 
 */
function updateMainBundleCounter(parentElement, productQty) {
  const counters = parentElement.querySelectorAll('.bundleItemList .smaller.counter');
  if (!counters.length) return;

  let minFullSets = Infinity;
  counters.forEach(counter => {
    const currentCount = parseInt(counter.dataset.count, 10) || 0;
    const destinationQty = parseInt(counter.dataset.destination, 10) || 1;
    const qtyPerSet = destinationQty / productQty;
    const fullSets = Math.floor(currentCount / qtyPerSet);
    minFullSets = Math.min(minFullSets, fullSets);
  });

  const groupedCounter = parentElement.querySelector('.grouped_counter_count');
  if (groupedCounter && minFullSets !== Infinity) {
    updateCounter(groupedCounter, minFullSets);
  }

  const mainCheckbox = parentElement.querySelector('.mainCheckbox');
  if (mainCheckbox) {
    if (minFullSets >= productQty) {
      mainCheckbox.classList.add('checked');
    } else {
      mainCheckbox.classList.remove('checked');
    }
  }
}